import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, Calendar, User } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data))
      .catch(() => setError("Post not found."))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="container-x py-32 text-center text-brand-muted">Loading...</div>;
  if (error || !post) {
    return (
      <div className="container-x py-32 text-center">
        <h1 className="font-display font-bold text-3xl mb-4">Post not found</h1>
        <Link to="/blog" className="btn-outline" data-testid="post-back">← Back to Blog</Link>
      </div>
    );
  }

  return (
    <article>
      <div className="container-x pt-20 pb-8">
        <Link to="/blog" data-testid="post-back" className="inline-flex items-center gap-1 text-sm text-brand-muted hover:text-brand-ink"><ArrowLeft className="w-4 h-4" /> Back to Blog</Link>
      </div>
      <div className="container-x pb-8">
        <div className="max-w-3xl">
          {post.tags?.[0] && <div className="text-xs px-2.5 py-1 rounded-full bg-brand-surface inline-block mb-6 text-brand-muted">{post.tags[0]}</div>}
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]" data-testid="post-title">{post.title}</h1>
          <div className="mt-6 flex flex-wrap items-center gap-5 text-sm text-brand-muted">
            <div className="flex items-center gap-2"><User className="w-3.5 h-3.5" /> {post.author}</div>
            <div className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5" /> {new Date(post.created_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</div>
          </div>
        </div>
      </div>
      {post.cover_image && (
        <div className="container-x mb-12">
          <img src={post.cover_image} alt={post.title} className="w-full aspect-[16/8] object-cover rounded-3xl" />
        </div>
      )}
      <div className="container-x pb-24">
        <div className="max-w-3xl prose-tn text-lg">
          {post.content.split("\n\n").map((para, i) => {
            if (para.startsWith("## ")) return <h2 key={i}>{para.slice(3)}</h2>;
            if (para.startsWith("### ")) return <h3 key={i}>{para.slice(4)}</h3>;
            return <p key={i}>{para}</p>;
          })}
        </div>
      </div>
    </article>
  );
}
